import React, { useState } from "react";
import store from "src/store";
import Button from "./button";
import CustomModal from "./custom-modal";
import { requestJSON } from "../utils/request-module"
import MyReviewForm from "./my-review-form";

export default function MyReviewsHeader() {
    const [showCreateReviewModal, setShowCreateReviewModal] = useState(false);
    const [newReviewName, setNewReviewName] = useState('');
    const [newReviewDescription, setNewReviewDescription] = useState('');
    const [newEngagementId, setnewEngagementId] = useState();
    const [newReviewNameHasError, setNewReviewNameHasError] = useState(false);
    const [newReviewNameErrorText, setNewReviewNameErrorText] = useState('');
    const [newEngagementIdHasError, setNewEngagementIdHasError] = useState(false);
    const [newEngagementIdErrorText, setNewEngagementIdErrorText] = useState('');
    const [availableResponse, setAvailableResponse] = useState(null);
    const [allowedVersions, setallowedVersions] = useState(0);
    const [versionAvailable, setVersionAvailable] = useState(false);
    const [saveMessage, setSaveMessage] = useState(null)



    const openCreateNewReviewModal = () => {
        let newReviewDefaultName = 'Version X'
        setNewReviewName(newReviewDefaultName);
        setNewReviewNameHasError(false);
        setNewReviewNameErrorText('');

        setNewReviewDescription('');

        setnewEngagementId(null);
        setNewEngagementIdHasError(false);
        setNewEngagementIdErrorText('');

        setAvailableResponse(null);
        setallowedVersions(0);
        setSaveMessage(null);

        setShowCreateReviewModal(true);
    }

    const onEngagementIdChange = (value) => {
        setnewEngagementId(value);

        if (!value) {
            setNewEngagementIdHasError(true);
            setNewEngagementIdErrorText('Engagement Id is required');
        } else {
            setNewEngagementIdHasError(false);
            setNewEngagementIdErrorText('');
            checkVersionAvailability(value);
        }
    }

    const onReviewNameChange = (value) => {
        setNewReviewName(value);

        if (!value) {
            setNewReviewNameHasError(true);
            setNewReviewNameErrorText('Version is required');
        } else {
            setNewReviewNameHasError(false);
            setNewReviewNameErrorText('');
        }
    }

    const onReviewDescriptionChange = (value) => {
        setNewReviewDescription(value);
    }

    const checkVersionAvailability = async (engagementId) => {
        if (!engagementId) return;
        setSaveMessage('validating');
        let url = '/engagement/check-engagement-availability?engagementId=' + encodeURIComponent(engagementId);
        try {
            const response = await requestJSON("GET", url);
            console.log("response", response);
            if (response === '' || response === undefined || Object.entries(response).length === 0) {
                setVersionAvailable(false);
                setSaveMessage('notAvailable');
            } else {
                setVersionAvailable(true);
                setAvailableResponse(response);
                setSaveMessage('available');
                setallowedVersions(getReviewVersionCount(response));
            }
        } catch (err) {
            setSaveMessage('notAvailable');
            setVersionAvailable(false);
        }
    }

    const getReviewVersionCount = (response) => {
        let reviewsCount = 0;
        // @ts-ignore
        if (response && response.length > 0) {
            // @ts-ignore
            const addedReviews = response[0]?.reviewData?.length;
            // @ts-ignore
            reviewsCount = response[0].maxAllowedVersion - addedReviews;
        }
        return reviewsCount;
    }

    const formIsValid = () => {
        let isValid = true;

        if (!newEngagementId) {
            isValid = false;
            setNewEngagementIdHasError(true);
            setNewEngagementIdErrorText('Engagement Id is required');
        } else {
            setNewEngagementIdHasError(false);
            setNewEngagementIdErrorText('');
        }

        if (!newReviewName) {
            isValid = false;
            setNewReviewNameHasError(true);
            setNewReviewNameErrorText('Version is required');
        } else {
            setNewReviewNameHasError(false);
            setNewReviewNameErrorText('');
        }

        if (!versionAvailable) {
            isValid = false;
        }
        return isValid;
    }

    const createReview = async () => {
        if (formIsValid() && allowedVersions > 0) {
            let reviewData = {
                name: newReviewName,
                // @ts-ignore
                engagement_id: availableResponse[0]['_id'],
                description: newReviewDescription
            }
            // @ts-ignore
            await store.createReview(reviewData);
            // store.checkAndSetMyReviewFilter();
            setShowCreateReviewModal(false);
        }
    }

    return (
        <>
            <CustomModal
                size="medium"
                title="Create new review"
                showModal={showCreateReviewModal}
                onCloseModal={() => { setShowCreateReviewModal(false) }}
                submitBtnText={'Create review'}
                onSubmit={() => { createReview() }}
                submitBtnDisabled={false}
            >
                <MyReviewForm
                    newEngagementId={newEngagementId}
                    newReviewName={newReviewName}
                    newReviewDescription={newReviewDescription}
                    onEngagementIdChange={(value) => onEngagementIdChange(value)}
                    onReviewNameChange={(value) => onReviewNameChange(value)}
                    onReviewDescriptionChange={(value) => onReviewDescriptionChange(value)}
                    newEngagementIdHasError={newEngagementIdHasError}
                    newEngagementIdErrorText={newEngagementIdErrorText}
                    newReviewNameHasError={newReviewNameHasError}
                    newReviewNameErrorText={newReviewNameErrorText}
                    availableResponse={availableResponse}
                    allowedVersions={allowedVersions}
                    saveMessage={saveMessage} />
            </CustomModal>

            <div css={`
                display: flex;
                flex-direction: row;
                align-items: center;
            `}>
                <div css={`
                    width: 80%;
                `}>
                    <div css={`
                        font-size:24px;
                        color:#2E2E38;
                    `}>
                        My reviews
                    </div>
                    <div css={` 
                        font-size:16px;
                        color:#2E2E38;
                        margin-top:12px;
                        `}>
                        <span>
                            The purpose of this tool is to establish a standard process for reviewing smart contracts. Although it will not teach you how to conduct an review, it will provide you with a comprehensive list of items that should be reviewed, so that nothing will be overlooked.
                        </span>
                    </div>
                </div>
                <div css={`
                    width: 20%;
                `}>
                    <div css={`
                    float: right
                    `}>
                        <Button variant="contained" color="secondary" onClick={() => { openCreateNewReviewModal() }}>New review</Button>
                    </div>
                </div>
            </div>
        </>
    )
}